import EventProvider from './components/event-provider';
import OutsidePressHandler from './components/outside-press-handler';

export { EventProvider };
export default OutsidePressHandler;
